module.exports = __webpack_public_path__ + "assets/img/20.3cb04eaf.svg";